<template>
  <div>
    <b-container fluid>
      <b-row class="contact-card">
        <b-col sm="3" class="contact-card-inner">
          <h5 class="footer-section-title">
            {{ contactTitle }}
            <span></span>
          </h5>
          <span></span>
          <div class="mt-2">
            <ul
              class="list-unstyled cnt"
              v-for="item in contacts"
              :key="item.sortId"
            >
              <li>
                <b-icon icon="house" font-scale="1.3" variant="white"></b-icon>
                <span class="ml">
                  {{ item.title }}
                </span>
              </li>
              <li>
                <b-icon icon="map" font-scale="1.3" variant="white"></b-icon>
                <span class="ml">
                  {{ item.address }}
                </span>
              </li>
              <li>
                <b-icon icon="phone" font-scale="1.3" variant="white"></b-icon>
                <span class="ml">
                  <a href="`tel:` + item.phoneNumberUrl">
                    {{ item.phoneNumber }}
                  </a>
                </span>
              </li>
              <li>
                <b-icon
                  icon="envelope"
                  font-scale="1.3"
                  variant="white"
                ></b-icon>
                <span class="ml">
                  <a href="`mailto:` + item.email">
                    {{ item.email }}
                  </a>
                </span>
              </li>
            </ul>
          </div>
          <b-row class="mt-2">
            <b-col>
              <img :src="images.logo" alt="ICMS" width="250" />
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="2" class="contact-card-inner">
          <h5 class="footer-section-title">
            {{ servicesTitle }}
            <span></span>
          </h5>
          <span></span>
          <div class="mt-2">
            <ul class="list-unstyled">
              <li
                v-for="item in services"
                :key="item.sortId"
                @click="scrollToTop"
              >
                <router-link :to="`/service/` + item.route">
                  {{ item.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </b-col>

        <b-col sm="2" class="contact-card-inner">
          <h5 class="footer-section-title">
            {{ quicklinkTitle }}
            <span></span>
          </h5>
          <span></span>
          <div class="mt-2">
            <ul class="list-unstyled">
              <li v-for="item in menus" :key="item.route">
                <router-link :to="item.link">
                  {{ item.name }}
                </router-link>
              </li>
              <li>
                <a href="#" target="_blank">Careers</a>
              </li>
            </ul>
          </div>
        </b-col>

        <b-col sm="2" class="contact-card-inner">
          <h5 class="footer-section-title">
            {{ externalLinkTitle }}
            <span></span>
          </h5>
          <span></span>
          <div class="mt-2">
            <ul class="list-unstyled">
              <li v-for="item in externalLinks" :key="item.sortId">
                <a :href="item.url" target="_blank">
                  {{ item.title }}
                </a>
              </li>
            </ul>
          </div>
        </b-col>

        <b-col sm="3" class="contact-card-inner">
          <h5 class="footer-section-title">
            {{ newsLetterTitle }}
            <span></span>
          </h5>
          <span></span>
          <div class="mt-2">
            <b-row class="mt-2">
              <b-col
                ><p>{{ subscriptionDescription }}</p>
                <validation-observer ref="observer">
                  <b-form
                    ref="subscribeForm"
                    @submit.prevent="sendSubscription()"
                  >
                    <validation-provider
                      name="Name"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                    >
                      <b-form-group id="name" label-for="name">
                        <b-form-input
                          id="name"
                          name="name"
                          placeholder="First Name & Surname"
                          v-model="name"
                          :state="getValidationState(validationContext)"
                          aria-describedby="name-live-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="name-live-feedback">{{
                          validationContext.errors[0]
                        }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      name="Email"
                      :rules="{ required: true, email: true, min: 3 }"
                      v-slot="validationContext"
                    >
                      <b-form-group id="email" label-for="email">
                        <b-form-input
                          id="email"
                          name="Email"
                          placeholder="Email Address"
                          v-model="email"
                          :state="getValidationState(validationContext)"
                          aria-describedby="email-live-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback id="email-live-feedback">{{
                          validationContext.errors[0]
                        }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <b-button
                      :disabled="processing"
                      class="white"
                      @click="sendSubscription()"
                    >
                      <b-icon
                        v-if="processing"
                        class="primary-color"
                        icon="soundwave"
                      ></b-icon>
                      <b-icon
                        v-else
                        icon="box-arrow-right"
                        font-scale="1"
                      ></b-icon>
                      {{ processing ? processingText : subscribeButton }}
                    </b-button>
                  </b-form>
                </validation-observer>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <footer-card></footer-card>
    </b-container>

    <back-to-top bottom="50px" right="50px">
      <b-button class="white">
        <b-icon icon="chevron-up" font-scale="1"></b-icon>
        TOP
      </b-button>
    </back-to-top>
  </div>
</template>

<script>
import { db } from "../firebase/db";
import FooterCard from "@/components/FooterCard.vue";

export default {
  components: {
    "footer-card": FooterCard
  },
  data() {
    return {
      drawer: true,
      fetching: true,
      images: {
        logo: require("@/assets/logo.png")
      },
      newsLetterTitle: "Newsletter Subscription",
      contactTitle: "Contact Information",
      servicesTitle: "Our Services",
      quicklinkTitle: "Quick Links",
      externalLinkTitle: "External Links",
      menus: [
        { name: "Home", link: "/" },
        { name: "About Us", link: "/about-us" },
        { name: "Our Services", link: "/our-services" },
        { name: "Media", link: "/news" },
        { name: "Contact Us", link: "/contact-us" }
      ],
      contacts: [],
      services: [],
      externalLinks: [],
      subscriptionTitle: "Newsletter",
      subscriptionDescription:
        "Fill form below to get first hand information about our products and services.",
      email: null,
      name: null,
      status: "Activated",
      subscribeButton: "SUBSCRIBE",
      processingText: "PROCESSING",
      processing: false,
      res: "",
      fab: false,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      phone: "+2348033204764",
      text: "",
      apilink: ""
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    sendSubscription() {
      if (this.name != null && this.email != null) {
        this.processing = true;
        db.collection("mailingList")
          .add({
            name: this.name,
            email: this.email,
            status: this.status
          })
          .then(result => {
            this.res = result;
            this.processing = false;
            this.$bvToast.toast(
              `You have successfully subscribbed to our mailing list. You are eligible to get our updates.`,
              {
                title: "Subscription Successful",
                autoHideDelay: 5000,
                variant: "success",
                toaster: "b-toaster-bottom-full"
              }
            );
            this.$refs.subscribeForm.reset();
          })
          .catch(error => {
            this.processing = false;
            this.$bvToast.toast(error, {
              title: "Subscription Failed",
              autoHideDelay: 5000,
              variant: "error",
              toaster: "b-toaster-bottom-full"
            });
          });
      } else {
        this.$bvToast.toast(
          `Kindly provide all required fields. Fields marked as * are required`,
          {
            title: "Subscription Failed",
            autoHideDelay: 5000,
            variant: "warning",
            toaster: "b-toaster-bottom-full"
          }
        );
      }
    }
  },
  firestore: {
    contacts: db.collection("contactUs"),
    services: db.collection("services").orderBy("sortId"),
    externalLinks: db.collection("externalLinks").orderBy("sortId")
  }
};
</script>

<style lang="scss" scoped>
.ml {
  margin-left: 10px;
}
.white {
  background: #ffffff;
}
.contact-card {
  // width: 100% !important;
  background: #314150;
  min-height: 200px;
  text-align: left !important;
}
.contact-card-inner {
  color: #cccccc;
  padding: 40px;
  font-size: 14px;
}
.contact-card-inner h5 {
  color: #ffffff;
  font-size: 17px;
  text-transform: uppercase;
  font-weight: 500 !important;
}
.contact-card-inner a {
  color: #90a4ae !important;
}
.contact-card-inner a:hover {
  color: #fff !important;
  text-decoration: none;
}
.contact-card-inner a:active {
  color: #fff !important;
  text-decoration: none;
}
</style>
